var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileXls = function SvgFileXls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#509E2F",
    d: "M15 0H4.125A1.12 1.12 0 0 0 3 1.12v21.755A1.12 1.12 0 0 0 4.12 24h15.755A1.123 1.123 0 0 0 21 22.88V6h-5.25a.75.75 0 0 1-.75-.75z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#509E2F",
    d: "M21 5.714V6h-5.25a.75.75 0 0 1-.75-.75V0h.286a1.13 1.13 0 0 1 .797.328l4.589 4.594a1.12 1.12 0 0 1 .328.792M3 14h18v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE8EF",
    d: "m7.788 18.588-1.41-2.112H7.83l.612 1.17.756-1.17h1.452l-1.494 2.112L10.842 21H9.408l-.906-1.476L7.44 21H6.018zM12.49 16.476v3.528h1.41V21h-2.586v-4.524zM17.062 17.634a1.4 1.4 0 0 0-.385-.228 1 1 0 0 0-.372-.078.6.6 0 0 0-.371.108.34.34 0 0 0-.144.282q0 .12.072.198t.185.138q.12.054.264.096.15.042.294.09.577.192.84.516.27.318.27.834 0 .348-.12.63-.114.282-.341.486a1.5 1.5 0 0 1-.553.306 2.2 2.2 0 0 1-.738.114q-.856 0-1.59-.51l.505-.948q.264.234.521.348.26.114.51.114.29 0 .426-.132a.4.4 0 0 0 .108-.474.35.35 0 0 0-.12-.138.9.9 0 0 0-.221-.12 6 6 0 0 0-.325-.12 9 9 0 0 1-.45-.156 1.5 1.5 0 0 1-.39-.234 1.1 1.1 0 0 1-.275-.36 1.3 1.3 0 0 1-.103-.558q0-.336.109-.606.113-.276.312-.468.204-.198.492-.306.294-.108.653-.108.337 0 .703.096.365.09.701.27z"
  }))));
};
export default SvgFileXls;